import { default as aboutLRsaFZT0KBMeta } from "/home/runner/work/livia_v0/livia_v0/pages/about.vue?macro=true";
import { default as bookingsW3v6r9eF0CMeta } from "/home/runner/work/livia_v0/livia_v0/pages/bookings.vue?macro=true";
import { default as _91city_93iWqakYO0WEMeta } from "/home/runner/work/livia_v0/livia_v0/pages/cities/[state]/[city].vue?macro=true";
import { default as city_45selectionelrkFuMA3YMeta } from "/home/runner/work/livia_v0/livia_v0/pages/city-selection.vue?macro=true";
import { default as comparestXrGO4cI6Meta } from "/home/runner/work/livia_v0/livia_v0/pages/compare.vue?macro=true";
import { default as conciergeMhBNp1h9YyMeta } from "/home/runner/work/livia_v0/livia_v0/pages/concierge.vue?macro=true";
import { default as contactdBYsT3y3obMeta } from "/home/runner/work/livia_v0/livia_v0/pages/contact.vue?macro=true";
import { default as forgot_45passwordJ0MjzkjmClMeta } from "/home/runner/work/livia_v0/livia_v0/pages/forgot-password.vue?macro=true";
import { default as indexoS8yAxlJmDMeta } from "/home/runner/work/livia_v0/livia_v0/pages/index.vue?macro=true";
import { default as loading4R8vP6i7qiMeta } from "/home/runner/work/livia_v0/livia_v0/pages/loading.vue?macro=true";
import { default as LoginGe2ZAlWGIOMeta } from "/home/runner/work/livia_v0/livia_v0/pages/Login.vue?macro=true";
import { default as logoutLZCuxd3xlaMeta } from "/home/runner/work/livia_v0/livia_v0/pages/logout.vue?macro=true";
import { default as neighborhood_45searchwzw4l7031hMeta } from "/home/runner/work/livia_v0/livia_v0/pages/neighborhood-search.vue?macro=true";
import { default as _91id_93voxc3hHJ2XMeta } from "/home/runner/work/livia_v0/livia_v0/pages/neighbourhoods/[id].vue?macro=true";
import { default as onboarding6xQz0nQkEmMeta } from "/home/runner/work/livia_v0/livia_v0/pages/onboarding.vue?macro=true";
import { default as planning9XvcAuNIqMMeta } from "/home/runner/work/livia_v0/livia_v0/pages/planning.vue?macro=true";
import { default as profile_45builderViEYnc2Nc3Meta } from "/home/runner/work/livia_v0/livia_v0/pages/profile-builder.vue?macro=true";
import { default as profile_45erroreFtT6wyWqRMeta } from "/home/runner/work/livia_v0/livia_v0/pages/profile-error.vue?macro=true";
import { default as profile_45loadingXXIr9qCh5rMeta } from "/home/runner/work/livia_v0/livia_v0/pages/profile-loading.vue?macro=true";
import { default as property_45search36RWqr8WiXMeta } from "/home/runner/work/livia_v0/livia_v0/pages/property-search.vue?macro=true";
import { default as _91property_id_93KWOhKS8qChMeta } from "/home/runner/work/livia_v0/livia_v0/pages/property/[state]/[listingType]/[property_id].vue?macro=true";
import { default as registrationRxIHsyraBIMeta } from "/home/runner/work/livia_v0/livia_v0/pages/registration.vue?macro=true";
import { default as servicesaikMSlc5SDMeta } from "/home/runner/work/livia_v0/livia_v0/pages/services.vue?macro=true";
import { default as verify_45emailjMRbGkWLpoMeta } from "/home/runner/work/livia_v0/livia_v0/pages/verify-email.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/about.vue")
  },
  {
    name: "bookings",
    path: "/bookings",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/bookings.vue")
  },
  {
    name: "cities-state-city",
    path: "/cities/:state()/:city()",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/cities/[state]/[city].vue")
  },
  {
    name: "city-selection",
    path: "/city-selection",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/city-selection.vue")
  },
  {
    name: "compare",
    path: "/compare",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/compare.vue")
  },
  {
    name: "concierge",
    path: "/concierge",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/concierge.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/contact.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/forgot-password.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/index.vue")
  },
  {
    name: "loading",
    path: "/loading",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/loading.vue")
  },
  {
    name: "Login",
    path: "/Login",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/Login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutLZCuxd3xlaMeta || {},
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/logout.vue")
  },
  {
    name: "neighborhood-search",
    path: "/neighborhood-search",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/neighborhood-search.vue")
  },
  {
    name: "neighbourhoods-id",
    path: "/neighbourhoods/:id()",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/neighbourhoods/[id].vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/onboarding.vue")
  },
  {
    name: "planning",
    path: "/planning",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/planning.vue")
  },
  {
    name: "profile-builder",
    path: "/profile-builder",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/profile-builder.vue")
  },
  {
    name: "profile-error",
    path: "/profile-error",
    meta: profile_45erroreFtT6wyWqRMeta || {},
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/profile-error.vue")
  },
  {
    name: "profile-loading",
    path: "/profile-loading",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/profile-loading.vue")
  },
  {
    name: "property-search",
    path: "/property-search",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/property-search.vue")
  },
  {
    name: "property-state-listingType-property_id",
    path: "/property/:state()/:listingType()/:property_id()",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/property/[state]/[listingType]/[property_id].vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/registration.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/services.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    component: () => import("/home/runner/work/livia_v0/livia_v0/pages/verify-email.vue")
  }
]